import { useSearchParams } from "react-router-dom";
import { Tag, Alert as AntAlert } from "antd";

const STATUSES = {
  CERRADA: "green",
  ABIERTA: "warning",
};

/**
 *  
 * Pedido	Producto	Detalle	Novedad	Estado	Prioridad	Cliente	Punto de venta	Responsable	Cedula	Abierto por	Fecha Novedad	Fecha cierre	Cerrado por Comentarios de cierre	Persona atendida
 
 */ 


export const columns = [
  {
    title: "Pedido",
    dataIndex: "pedido",
    key: "pedido",
  },
  {
    title: "Producto",
    dataIndex: "producto",
    key: "producto",
  },
  {
    title: "Detalle",
    dataIndex: "detalle",
    key: "detalle",
  },
  {
    title: "Novedad",
    dataIndex: "novedad",
    key: "novedad",
  },
  {
    title: "Estado",
    dataIndex: "estado",
    key: "estado",
    render: (_, record) => (
      <span>
        <Tag color={STATUSES[record.estado]}>
         {record.estado}
        </Tag>
      </span>
    ),
  },
  {
    title: "Prioridad",
    dataIndex: "prioridad",
    key: "prioridad",
  },
  {
    title: "Cliente",
    dataIndex: "cliente",
    key: "cliente",
  },
  {
    title: "Punto de Venta",
    dataIndex: "puntoVenta",
    key: "puntoVenta",
  },
  {
    title: "Responsable",
    dataIndex: "responsable",
    key: "responsable",
    render: (text) => text.replace("|", " ").toUpperCase(),
  },
  {
    title: "Cedula",
    dataIndex: "cedula",
    key: "cedula",
  },
  {
    title: "Abierto por",
    dataIndex: "abiertoPor",
    key: "abiertoPor",
  },
  {
    title: "Fecha Novedad",
    dataIndex: "fechaNovedad",
    key: "fechaNovedad",
  },
  {
    title: "Fecha Cierre",
    dataIndex: "fechaCierre",
    key: "fechaCierre",
  },
  {
    title: "Cerrado por",
    dataIndex: "cerradoPor",
    key: "cerradoPor",
  },  
  {
    title: "Comentarios Cierre",
    dataIndex: "comentariosCierre",
    key: "comentariosCierre",
  },
  {
    title: "Persona Atendida",
    dataIndex: "personaAtendida",
    key: "personaAtendida",
  },
];

export const InconsistentMsg = ({ count, onClick }) => {
  return (
    <AntAlert
      message={
        <>
          Existen <b>{count}</b> pedidos que presentan Incosistencia. Haz click
          en corregir para resolverlas.
        </>
      }
      type="error"
      showIcon
      onClick={onClick}
    />
  );
};

export const LogisticAlertMsg = ({ count, onClick }) => {
  return (
    <AntAlert
      message={
        <>
          Existen <b>{count}</b> pedidos que presentan Incosistencia. Haz click
          en corregir para resolverlas.
        </>
      }
      type="warning"
      showIcon
      onClick={onClick}
    />
  );
};

export function useQueryParams(params) {
  const [searchParams, setSearchParams] = useSearchParams();
  setSearchParams({ ...searchParams, params });
}
